import React from 'react';
import PropTypes from 'prop-types';
import { Alert, PageHeader } from 'react-bootstrap';

const NotFound = ({ message }) => {

  return (
    <div>
      <PageHeader>404: Not Found</PageHeader>
      <Alert bsStyle="info">
        <h4>Sorry, we can't find the page you're looking.</h4>
        <p>{message || 'No additional information available'}</p>
      </Alert>
    </div>
  )
}

NotFound.propTypes = {
  message: PropTypes.string
};

export default NotFound



// WEBPACK FOOTER //
// ./src/components/notFound/NotFound.js